/**
 * Activity tracking endpoints.
 */
import type {
  ActivityContentType,
  EndActivityResponse,
  StartActivityResponse,
} from '@/types/api';
import { apiClient } from './client';

// ============================================================================
// ACTIVITY TRACKING - used by useActivityTracking hook
// ============================================================================

export const activityApi = {
  /** Called on tab/content mount. Returns the activity_id to pass to endActivity later. */
  startActivity: (
    contentType: ActivityContentType,
    lessonId?: string,
    conceptId?: string
  ) =>
    apiClient.post<StartActivityResponse>('/analytics/activity/start', {
      content_type: contentType,
      lesson_id: lessonId,
      concept_id: conceptId,
    }),

  /**
   * Time spent with lesson concepts on screen (a text section, a highlight
   * card), summed on the page: credited to the student's Mindspace concepts.
   */
  creditConceptTime: (
    lessonId: string,
    items: { concept_ids: string[]; seconds: number }[]
  ) =>
    apiClient.post<{ credited: number }>('/analytics/concept-time', {
      lesson_id: lessonId,
      items,
    }),

  /** Called on tab/content unmount. Closes the activity, computes duration. */
  endActivity: (activityId: string) =>
    apiClient.post<EndActivityResponse>(
      `/analytics/activity/${activityId}/end`
    ),
};

// ============================================================================
// PROGRESS - per-lesson and user-level (Progress page)
// ============================================================================
